import firebase from 'firebase';

var firebaseConfig = {
    apiKey: "AIzaSyAHZMoizzwihy1naA1dtGyT2vXGr96QafI",
    authDomain: "nothing-store.firebaseapp.com",
    projectId: "nothing-store",
    storageBucket: "nothing-store.appspot.com",
    messagingSenderId: "408888037941",
    appId: "1:408888037941:web:9025081981184e29b8977c",
    measurementId: "G-XKNTK0MH44"
  };
  

  const fire = firebase.initializeApp(firebaseConfig);

export default fire;